import {useApi} from "../Api";

export const useConfigurationRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/configurations";

    function getConfigurationParameter({parameter}: { parameter: string }): Promise<string | number | null> {
        return GET(`${PATH}/${parameter}`);
    }

    return {getConfigurationParameter};
};